import { resolveImportSource } from "./resolveImportSource.js";
export function getContextReference(path, state, app, options) {
  var _options$contextBindi;
  if (!path.isReferencedIdentifier()) {
    return null;
  }
  var contextName = path.node.name;
  var binding = path.scope.getBinding(contextName);
  if (!binding) {
    return null;
  }
  if ((_options$contextBindi = options.contextBindings) !== null && _options$contextBindi !== void 0 && _options$contextBindi.has(binding.identifier)) {
    return {
      type: "local",
      name: contextName
    };
  }
  if (binding.kind === "module") {
    if (binding.path.isImportSpecifier() && binding.path.parentPath.isImportDeclaration()) {
      var imported = binding.path.get("imported");
      if (!imported.isIdentifier()) {
        state.errors.push({
          message: "Unsupported import specifier type: ".concat(imported.type),
          node: imported.node,
          severity: "error"
        });
        return null;
      }
      var source = binding.path.parentPath.get("source");
      return {
        type: "imported",
        name: imported.node.name,
        importSource: resolveImportSource(source.node.value, state.filePath, app.files)
      };
    }
  }
  state.errors.push({
    message: "Unsupported context binding for \"".concat(contextName, "\""),
    node: binding.identifier,
    severity: "error"
  });
  return null;
}
export function getContextReferenceVariableName(refName, getterName) {
  return "CONTEXT_PROVIDER__".concat(refName, "__").concat(getterName);
}
export function getContextReferenceEventAgentId(refName) {
  return "context-agent-".concat(refName);
}
//# sourceMappingURL=getContextReference.js.map